export default __webpack_public_path__ + "static/BloodPressure-f77e22c113e40f33b6e3310eca4638ce.jpg";